import type { ErrorTranslations } from "./utils";

export default {
  totp_required: {
    EN: "TOTP required",
    RO: "TOTP necesar",
  },
  too_many_requests: {
    EN: "Too many requests. Please try again later.",
    RO: "Ați efectuat prea multe request-uri. Vă rugăm încercați din nou mai târziu.",
  },
  not_found: {
    EN: "Not found",
    RO: "Nu a fost găsit",
  },
  internal_error: {
    EN: "Internal error, please try again later",
    RO: "A apărut o eroare, vă rugăm încercați din nou",
  },
  unauthorized: {
    EN: "Unauthorized.",
    RO: "Neautorizat.",
  },
  already_logged_in: {
    EN: "You are already logged in.",
    RO: "Sunteți deja autentificat.",
  },
  forbidden: {
    EN: "Forbidden operation",
    RO: "Operațiune interzisă",
  },
  recaptcha_failed: {
    EN: "Recaptcha failed",
    RO: "Recaptcha a eșuat",
  },
  invalid_token: {
    EN: "Invalid token",
    RO: "Token invalid",
  },
  bad_request: {
    EN: "Bad request",
    RO: "Cerere greșită",
  },
  locked_out: {
    EN: "You are locked out",
    RO: "Sunteți blocat",
  },
  user_no_valid_institution: {
    EN: "User does not belong to a valid institution",
    RO: "Utilizatorul nu aparține unei instituții valide",
  },
} satisfies ErrorTranslations;
